import React, { Component } from 'react'
import { PrimaryButton } from 'src/components/buttons/PrimaryButton'
import { st } from 'src/locales'
import { LoadingStore } from 'src/stores/LoadingStore'
import { PaymentMethodStore } from 'src/stores/PaymentMethodStore'

interface IProps {
  handleAfterSetDefault: () => void
  paymentMethodId: string | null
}

export class PaymentDefaultButton extends Component<IProps> {
  private readonly loadingStore = new LoadingStore()
  public handleMakeDefault = async () => {
    await this.loadingStore.execute(PaymentMethodStore.setDefault(this.props.paymentMethodId))
    this.props.handleAfterSetDefault()
  }

  public render() {
    return (
      <PrimaryButton
        loading={this.loadingStore.isLoading()}
        title={st.screens.viewPaymentMethod.makeDefault()}
        onPress={this.handleMakeDefault}
      />
    )
  }
}
